import styled from 'styled-components/macro'

export const Wrapper = styled.p`
  font-size: 14px;
  background: ${props => props.theme.accent}22;
  border-radius: 8px;
  margin-top: 8px;
  padding: 8px 16px;

  svg {
    color: ${props => props.theme.accent};
  }
`
